export enum Criteria {
    NAME = 'Name',
    NIN = 'NIN',
    BIRTH_DATE = 'Birth Date',
    ADDRESS = 'Address'
}